export default __webpack_public_path__ + "static/aPP-e6fdbe1f5b59623f963c166c444da739.png";